const STORAGE_KEY = 'trustchat.notificationsBackground';

/**
 * React Router v6 stores location.state under history.state.usr.
 * Fall back to top-level and sessionStorage for reliability.
 */
export function readNotificationsBackground() {
  const hist = window.history.state;
  const fromHistory =
    hist?.usr?.backgroundLocation || hist?.backgroundLocation;
  if (fromHistory?.pathname) return fromHistory;

  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed?.pathname) return parsed;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function saveNotificationsBackground(locationLike) {
  if (!locationLike?.pathname) return;
  const snapshot = {
    pathname: locationLike.pathname,
    search: locationLike.search || '',
    hash: locationLike.hash || '',
  };
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
  } catch {
    /* ignore */
  }
  return snapshot;
}

export function clearNotificationsBackground() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function pathFromBackground(background) {
  if (!background?.pathname) return '/dashboard';
  return `${background.pathname}${background.search || ''}${background.hash || ''}`;
}
